import React, { useState, useEffect } from "react";
import NavbarLeft from "../Components/NavbarLeft";
import AddUserMenu from "./components/AddUserMenu";
import GeneralParameters from "./components/GeneralParameters";
import LogOut from "./components/LogOut";
import UsersList from "./components/UsersList";
import Subscription from "./components/Subscription";

import { isLoaded, isEmpty } from "react-redux-firebase";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { getFreeSubscriptionDaysLeft, fetchProducts } from "../../redux/actions/userActions";

const ProfilePage = (props) => {
  // const {selected_page} = useParams();
  // is_end_trial
  const user_info = useSelector((state) => (state.user.user_info ? state.user.user_info : null));
  const products = useSelector((state) => (state.user.products ? state.user.products : null));
  // const is_end_trial = getFreeSubscriptionDaysLeft(user_info) <= 0;
  const current_period = useSelector((state) => (state.user.subscription_days_left ? state.user.subscription_days_left : null));
  const [selected, setSelected] = useState(current_period <=0 ? 3 : 1);
  const [addMenu, setAddMenu] = useState(0);
  const [is_modify_user, set_is_modify_user] = useState(false);
  const [to_modify, set_to_modify] = useState(null);
  // const auth = useSelector((state) => state.firebase.auth);

  const dispatch = useDispatch();
  const fetchProducts_rd = () => dispatch(fetchProducts());

  useEffect(() => {
    const fetch_fn = async () => {
      await fetchProducts_rd();
    };
    // if (!products) {
      fetch_fn();
    // }
  }, []);

  return (
    <>
      {addMenu ? <AddUserMenu addMenu={addMenu} setAddMenu={setAddMenu} is_modify_user={is_modify_user} to_modify={to_modify} /> : null}
      <NavbarLeft currentPage={0} />
      <div className="w-full h-[70px] bg-white border-r-[1px] border-[#BEC4C] fixed z-10 flex items-center justify-start ml-[25px]">
        <div className="w-full relative left-[70px] flex justify-start items-center">
          <p className="font-Poppins-SemiBold text-lg relative p-10">Profile</p>
        </div>
      </div>
      <div className="h-full w-ful flex items-center justify-center">
        <div>
          <div className="w-[1000px] h-[80px] bg-white rounded-lg flex justify-center items-center">
            <div className="h-full w-[800px] flex justify-evenly items-end">
              <div onClick={() => !(current_period <=0) && setSelected(1)} className="">
                <p className={`${selected === 1 ? "text-mainGreen" : "text-gray-400"} ${!(current_period <=0) ? "cursor-pointer" : ""} text-center`}>Paramètres généraux</p>
                <div className={`w-[200px] ${selected === 1 ? "bg-mainGreen" : null} h-[3px] mt-[25px] rounded-full`}></div>
              </div>
              <div onClick={() => !(current_period <=0) && setSelected(2)}>
                <p className={`${selected === 2 ? "text-mainGreen" : "text-gray-400"} ${!(current_period <=0) ? "cursor-pointer" : ""} text-center`}>Utilisateurs</p>
                <div className={`w-[200px] ${selected === 2 ? "bg-mainGreen" : null} h-[3px] mt-[25px] rounded-full`}></div>
              </div>
              <div onClick={() => setSelected(3)}>
                <p className={`${selected === 3 ? "text-mainGreen" : "text-gray-400"} cursor-pointer text-center`}>Abonnement</p>
                <div className={`w-[200px] ${selected === 3 ? "bg-mainGreen" : null} h-[3px] mt-[25px] rounded-full`}></div>
              </div>
              <div onClick={() => setSelected(4)}>
                {/* <p className={`${selected === 4 ? "text-mainGreen" : "text-gray-400"} ${!(current_period <=0) ? "cursor-pointer" : ""} text-center`}>Se déconnecter</p> */}
                <p className={`${selected === 4 ? "text-mainGreen" : "text-gray-400"} cursor-pointer text-center`}>Se déconnecter</p>
                <div className={`w-[200px] ${selected === 4 ? "bg-mainGreen" : null} h-[3px] mt-[25px] rounded-full`}></div>
              </div>
            </div>
          </div>

          <div className="w-[1000px] h-[480px] mt-[20px] bg-white rounded-lg shadow-lg border-[2px] border-gray-500/10">
            {selected === 1 ? <GeneralParameters /> : null}

            {selected === 2 ? <UsersList setAddMenu={setAddMenu} set_is_modify_user={set_is_modify_user} set_to_modify={set_to_modify} /> : null}

            {selected === 3 ? <Subscription setAddMenu={setAddMenu} /> : null}

            {selected === 4 ? <LogOut /> : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProfilePage;
